/**
 * Styles react-select partagés entre les pages.
 * defaultSelectStyles : bordure claire (#d8c8b8), pour PaieMoisPage, PointagePage.
 * brownSelectStyles   : bordure foncée (#6d4e36), pour PointageJournalierPage, PointageMaterielPage.
 */

export const defaultSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 42,
    borderColor: '#d8c8b8',
    boxShadow: 'none',
    ':hover': { borderColor: '#8b5e3c' }
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 99999
  })
};

export const brownSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 42,
    borderColor: '#6d4e36',
    boxShadow: 'none',
    ':hover': { borderColor: '#8b5e3c' }
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 99999
  })
};
